export default "__VITE_ASSET__B33KS2jB__"